/**
 * This was previously defined in the `ui/sidebar.tsx` file which has the "use client" directive.
 * If it was imported in a server component, it would be a function not a string.
 * So we define it here in a non-client scope so that it can be safely imported in client and server scopes.
 */
export const SIDEBAR_COOKIE_NAME = 'sidebar:state';
